import React from 'react';
import Image from 'next/image';

const FinTechNumbers = () => {
    return (
        <div className="section-py bg-primary_one relative">
            <div className="bg-agriculture-numbers">
                <Image
                    src="/img/fintech-industry/svg/vector-fintech-the-future-is-now.svg"
                    className="img-fluid !h-full"
                    alt="fintech-the-future"
                    title="fintech-the-future"
                    height={385}
                    width={1380}
                    loading="lazy"
                />
            </div>
            <div className="container xl:container mx-auto z-[1] relative">
                <div className="row grid lg:grid-cols-12 mb-9">
                    <div className="lg:col-span-10 gap-4 grid">
                        <h2 className="text-white mb-0">FinTech: The Future is Now</h2>
                    </div>
                </div>
                <div className="row grid xl:grid-cols-4 lg:grid-cols-4 md:grid-cols-4 grid-cols-2">
                    <div className="">
                        <p className="text-white mb-4 font-bold fs-xxl">$179B</p>
                        <p className="text-white opacity-[0.8] mb-0 fs-md">
                            $179 billion market value of the global FinTech sector in 2024
                        </p>
                    </div>
                    <div className="">
                        <p className="text-white mb-4 font-bold fs-xxl">30%</p>
                        <p className="text-white opacity-[0.8] mb-0 fs-md">
                            30% YoY growth in demand for digital banking and money transfer services
                        </p>
                    </div>
                    <div className="">
                        <p className="text-white mb-4 font-bold fs-xxl">88%</p>
                        <p className="text-white opacity-[0.8] mb-0 fs-md">
                            88% of financial institutions are actively investing in FinTech solutions
                        </p>
                    </div>
                    <div className="">
                        <p className="text-white mb-4 font-bold fs-xxl">$10B+</p>
                        <p className="text-white opacity-[0.8] mb-0 fs-md">
                            $10 billion+ saved annually by implementing AI in financial software development
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default FinTechNumbers;
